<template>
  <page :title="pageTitle" backTo="/collections" :loading="collection.data == null" size="is-desktop">
    <div slot="page-header-right">
      <button @click="destroy" class="button is-danger  mr-2">
        Delete
      </button>

      <button
        @click="update"
        class="button is-primary"
        :class="{ 'is-loading': form.processing }"
      >
        Update Collection
      </button>
    </div>

    <form @submit.prevent="update">
      <div class="columns" v-if="collection">
        <div class="column is-4">
          <div class="box">
            <b-field label="Name">
              <b-input type="text" v-model="form.name" readonly></b-input>
            </b-field>

            <b-field label="Slug">
              <b-input type="text" v-model="form.slug" readonly></b-input>
            </b-field>

            <b-field label="Locale">
              <b-select v-model="form.locale">
                <option :value="key" v-for="(label, key) in languages" :key="key">
                  {{ label }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="Title">
              <b-input type="text" v-model="form.title"></b-input>
            </b-field>

            <b-field label="Title(MN)">
              <b-input type="text" v-model="form.mn_title"></b-input>
            </b-field>

            <div class="columns">
              <div class="column is-6">
                <b-field label="Amount">
                  <b-input type="number" v-model="form.amount"></b-input>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field label="Order">
                  <b-input type="number" v-model="form.order"></b-input>
                </b-field>
              </div>
            </div>

            <b-field>
              <b-switch
                v-model="form.is_show"
                @input="toggleShow(form.is_show)"
              >
                <span v-if="form.is_show">Show</span>
                <span v-else>Hide</span>
              </b-switch>
            </b-field>
          </div>

          <div class="box" v-if="collection.data.has_collector">
            <p class="title is-5">Auto collector</p>

            <b-field>
              <b-switch
                v-model="collection.data.has_active_collector"
                @input="toggleCollector(!collection.data.has_active_collector)"
              >
                <span v-if="collection.data.has_active_collector">Active</span>
                <span v-else>Inactive</span>
              </b-switch>
            </b-field>

            <hr/>

            <button class="button" type="button" @click="recollect" :class="{ 'is-loading': recollecting }">
              <b-icon icon="refresh"></b-icon>
              <span>Run the auto collector</span>
            </button>
          </div>
        </div>

        <div class="column is-8">
          <div class="box">
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Items</p>
              </div>

              <div class="level-right">
                <b-dropdown position="is-bottom-left">
                  <a slot="trigger">Add</a>

                  <div class="dropdown-item" style="min-width: 300px;">
                    <add-issue-modal :collection-id="collection.data.id" :type="collection.data.type"
                                     @added="onAdd"></add-issue-modal>
                  </div>
                </b-dropdown>
              </div>
            </div>

            <issue-list v-if="collection.data.type == 'issue'" ref="list">
            </issue-list>

            <magazine-list v-if="collection.data.type == 'magazine'" ref="list">
            </magazine-list>

            <feed-list v-if="collection.data.type == 'feed'" ref="list">
            </feed-list>

          </div>
        </div>
      </div>
    </form>
  </page>
</template>

<script>
import AddIssueModal from "./components/AddIssueModal";
import IssueList from "./components/CollectionIssueList";
import MagazineList from "./components/CollectionMagazineList";
import FeedList from "./components/CollectionFeedList";
import {getActiveLanguages} from "../../../../data/languages";

export default {
  components: {
    AddIssueModal,
    MagazineList,
    IssueList,
    FeedList
  },

  data() {
    let languages = getActiveLanguages();

    return {
      newId: null,

      collection: new window.RemoteData(`/admin/api/collections/${this.$route.params.id}/show`),

      recollecting: false,

      form: null,
      languages,
    };
  },

  created() {
    this.collection.load(() => {
      this.form = new window.Form({
        name: this.collection.data.name,
        slug: this.collection.data.slug,
        title: this.collection.data.title,
        locale: this.collection.data.locale,
        mn_title: this.collection.data.mn_title,
        order: this.collection.data.order,
        amount: this.collection.data.amount,
        is_show: this.collection.data.is_show,
      });
    });
  },

  computed: {
    pageTitle() {
      return this.collection.data ? "Collection - #" + this.collection.data.id : "";
    }
  },

  watch: {
    $route() {
      this.collection = null;

      this.load();
    }
  },

  methods: {
    addIssue() {
      this.$buefy.modal.open({
        component: AddIssueModal,
        props: {
          collectionId: this.collection.id
        }
      });
    },

    onAdd(data) {
      this.$refs.list.reload();
    },

    toggleCollector(value) {
      this.$http[value ? "post" : "delete"](
        "/admin/api/collections/" + this.collection.data.id + "/collector"
      ).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });
      });
    },

    toggleShow(value) {
      this.$http[value ? "post" : "delete"](
        "/admin/api/collections/" + this.collection.data.id + "/switch"
      ).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });
      });
    },

    recollect() {
      this.recollecting = true;

      this.$http
        .post("/admin/api/collections/" + this.collection.data.id + "/recollect")
        .then(() => {
          this.recollecting = false;

          this.$refs.list.reload();
        });
    },

    confirm(onConfirm) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message:
          "You are deleting a Collection. You cannot restore it when its deleted.",
        cancelText: "Cancel",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm,
      });
    },

    destroy() {
      this.confirm(() => {
        this.$http
          .delete(`/admin/api/collections/${this.collection.data.id}`)
          .then((response) => {
            this.$buefy.toast.open(response.data.message);
            this.$router.push("/collections");
          })
          .catch((error) => {
            new window.FailedResponseHandler(error).handle();
          });
      });
    },

    update() {
      this.form
        .put(`/admin/api/collections/${this.$route.params.id}`)
        .then(({message}) => {
          this.$buefy.toast.open(message);
        });

      this.$router.push("/collections");
    }
  }
};
</script>
